export const isSk = process.env.GATSBY_APP_TYPE === 'sk'

export const isCs = process.env.GATSBY_APP_TYPE === 'cs'

export const isVersion = version => process.env.GATSBY_APP_TYPE === version
